var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "site-list" },
    _vm._l(_vm.siteList, function (item) {
      return _c(
        "div",
        {
          key: item.siteId,
          staticClass: "item",
          on: {
            click: function ($event) {
              return _vm.goToClient(item)
            },
          },
        },
        [
          item.ifTestSite
            ? _c("img", {
                staticClass: "demo-site-watermark",
                attrs: { src: require("@/assets/img/demo_site.svg") },
              })
            : _vm._e(),
          _c("div", { staticClass: "set-icon" }, [
            _c("img", {
              staticClass: "pin-normal",
              attrs: { src: !item.ifPin ? _vm.notPinIcon : _vm.pinedIcon },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.updatePinStatus(item)
                },
              },
            }),
            _c("img", {
              staticClass: "pin-hover",
              attrs: {
                src: !item.ifPin ? _vm.notPinIconHover : _vm.pinedIconHover,
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.updatePinStatus(item)
                },
              },
            }),
          ]),
          _c("div", { staticClass: "siteItem" }, [
            _c("div", { staticClass: "first-word" }, [
              _vm._v("\n        " + _vm._s(item.clientName[0]) + "\n      "),
            ]),
            _c("div", { staticClass: "info" }, [
              _c(
                "p",
                { staticClass: "c-name", attrs: { title: item.clientName } },
                [_vm._v(_vm._s(item.clientName))]
              ),
              _c(
                "p",
                { staticClass: "s-name", attrs: { title: item.siteName } },
                [_vm._v(_vm._s(item.siteName))]
              ),
            ]),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }